// APIs/generateJWT.js
import axios from 'axios';

export const generateJWT = async (email, tenantId, userRole) => {
  const apiUrl = process.env.REACT_APP_JWT_API;
  const appId = process.env.REACT_APP_APP_ID;
  
  // Check if the API URL is loaded correctly
  if (!apiUrl) {
    console.error('REACT_APP_JWT_API is not defined in the environment variables');
    return;
  }

  try {
    const response = await axios.post(apiUrl, {
      email,
      tenantId,
      userRole,
      applicationId: appId,
    });

    return response.data; // Return the response data containing the token
  } catch (error) {
    console.error("Error generating JWT:", error.response ? error.response.data : error.message);
    throw error;
  }
};
